// const modeloDeDados = [{
//   _id: "6851de797a2044a2b36e641a",
//   origin: "https://teste2.com.br",
//   fields: ["prop1", "prop2", "prop3"],
//   charactersLimit: 100,
//   cache: ["texto de exemplo da prop1", "texto de exemplo da prop2", "texto de exemplo da prop3"],
//   active: false
// },{
//   _id: "7851de797a2044a2b36e641b",
//   origin: "https://teste.com.br",
//   fields: ["prop1", "prop2", "prop3"],
//   charactersLimit: 100,
//   cache: ["texto de exemplo da prop1", "texto de exemplo da prop2", "texto de exemplo da prop3"],
//   active: false
// }];

const state = () => ({
  data: [],
  total: 0,
  showRemoveLetreiro: false,
  dataIdForDelete: "",
  dataToLetreiro: {},
  loading: false
})

const mutations = {
  setDataIdForDelete(state, dataIdForDelete){
    state.dataIdForDelete = dataIdForDelete
  },
  setData(state, data){
    state.data = data
  },
  setTotal(state, total) {
    state.total = total
  },
  setRemoveLetreiro(state, value){
    state.showRemoveLetreiro = value
  },
  removeDataById(state){
    state.data = state.data.filter(item => item._id !== state.dataIdForDelete)
    state.total = Math.max(0, state.total - 1)
  },
  setDataToLetreiro(state, data){
    state.dataToLetreiro = data
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  addLetreiro(state, letreiro) {
    state.data.push(letreiro)
    state.total += 1
  },
  updateLetreiro(state, updatedLetreiro) {
    const index = state.data.findIndex(item => item._id === updatedLetreiro._id)
    if (index !== -1) {
      state.data.splice(index, 1, updatedLetreiro)
    }
  },
  removeLetreiro(state, id) {
    state.data = state.data.filter(item => item._id !== id)
    state.total = Math.max(0, state.total - 1)
  }
}

export default {state, mutations, namespaced: true}
